// ============================================
// INFRASTRUCTURE - Categorías Almacén Repository
// ============================================

import { axiosClient } from './axios-client';
import type { CategoriaAlmacen } from '../../domain/entities';

export const categoriasAlmacenRepository = {
  async getAll(): Promise<CategoriaAlmacen[]> {
    const { data } = await axiosClient.get<CategoriaAlmacen[]>('/categorias-almacen');
    return data;
  },

  async create(nombre: string): Promise<CategoriaAlmacen> {
    const { data } = await axiosClient.post<CategoriaAlmacen>('/categorias-almacen', { nombre });
    return data;
  },

  async update(id: number, nombre: string): Promise<CategoriaAlmacen> {
    const { data } = await axiosClient.patch<CategoriaAlmacen>(`/categorias-almacen/${id}`, { nombre });
    return data;
  },

  async remove(id: number): Promise<void> {
    await axiosClient.delete(`/categorias-almacen/${id}`);
  },

  async assignToProduct(productoAlmacenId: number, categoriaAlmacenId: number): Promise<CategoriaAlmacen> {
    const { data } = await axiosClient.put<CategoriaAlmacen>(
      `/productos-almacen/${productoAlmacenId}/categoria/${categoriaAlmacenId}`
    );
    return data;
  },

  async removeFromProduct(productoAlmacenId: number): Promise<void> {
    await axiosClient.delete(`/productos-almacen/${productoAlmacenId}/categoria`);
  },
};
